export enum ProcessWidgetLink {
    BusinessNavigator = 100,
    ProcessOverview = 200,
}

// The string values are i18n keys resolved via the `transloco` pipe at the display site
export const ProcessWidgetLinkDescription: { [type in ProcessWidgetLink]: string } = {
    100: "dashboard.widgetCatalog.processWidgetLinkBusinessNavigatorOption",
    200: "dashboard.widgetCatalog.processWidgetLinkProcessOverviewOption",
};
